import { render, staticRenderFns } from "./NewComplaintEmisor.vue?vue&type=template&id=00cb8e46"
import script from "./NewComplaintEmisor.vue?vue&type=script&lang=js"
export * from "./NewComplaintEmisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports